<!-- CẤU HÌNH GIAO DIỆN -->
<div class="shape">
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config [device]="device" [elementChoosing]="objectChoosing" [width]="class['shape']['width']"
      [height]="class['shape']['height']" (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <!-- LOẠI HÌNH DẠNG -->
    <ul nz-menu nzMode="inline" nzInlineCollapsed="false" *ngIf="class.shape.type_item == 'shape'">
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <!-- Lựa chọn hiển thị cho các thiết bị -->
        <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
        </app-hide-show-config>
      </li>
      <!-- Cấu hình tái sử dụng thiết kế-->

      <!-- CẤU HÌNH HÌNH DẠNG -->
      <li nz-submenu nzTitle="{{'dang_hinh' | translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <div class="field">
          <!-- CHỌN MẪU HÌNH DẠNG -->
          <div class="items">
            <div class="items__type">
              <div class="items__content" *ngFor="let item of clipPaths" (click)="chooseItem(item, $event)"
              [class.active]="class.shape__parent['clip-path'] == item.clipPath && class.shape__child['clip-path'] == item.clipPath">
                <button [ngStyle]="{
                          'background-color': '#ffd400',
                          'clip-path': item.clipPath
                        }"></button>
              </div>
            </div>
          </div>
          <!-- Tuỳ chỉnh cho cấu hình này -->
          <div class="items__type-custom mt-2 mb-2">
            <!-- Mở popup chỉnh sửa hình dạng -->
            <button 
            nz-row (click)="openEditShape()"
            class="w-100 p-2 d-flex justify-content-center"
            style="color: #fff; background-color: #00a859; font-size: 14px; border-radius: 8px;">
              {{ 'mo_chinh_sua_hinh_dang' | translate }}
            </button>
          </div>
          <div class="mt-2">
            <label>{{ 'kieu_hien_thi' | translate }}</label>
            <nz-radio-group [(ngModel)]="config['background-color'].bg_check" (ngModelChange)="updateBgCheck()">
              <label nz-radio nzValue="color">{{ 'mau_sac' | translate }}</label>
              <label nz-radio nzValue="image">{{ 'chua_anh_ben_trong' | translate }}</label>
            </nz-radio-group>
          </div>
          <hr style="background-color: #dddddd">
          <div class="check-option" *ngIf="config['background-color'].bg_check === 'color'">
            <div class="items">
              <p class="title">{{ 'do_mau_gradient' | translate }}</p>
              <nz-switch [(ngModel)]="config['background-color'].gradient_check"
                (ngModelChange)="updateBackgroundRgb()"></nz-switch>
            </div>
            <div class="container-gradient" *ngIf="config['background-color'].gradient_check">
              <div class="list-gradient">
                <button class="btn-gradient" *ngFor="
                      let bgGradient of config['background-color']['gradient_arr'];
                      let i = index
                    " (click)="deleteGradient(i)" [ngStyle]="{ 'background-color': bgGradient }">
                  <i class="delete-icon bi bi-x-circle"></i>
                </button>
              </div>
              <div class="my-3">
                <p class="">{{ 'them_mau' | translate }}</p>
                <div class="my-1">
                  <input class="input-color" [cpOKButton]="true" [(colorPicker)]="class['shape__child']['background']"
                    type="button" [style.background]="class['shape__child']['background']"
                    (colorPickerClose)="addGradient($event)" />
                </div>
              </div>
              <p class="title-head">{{ 'huong_phoi_mau' | translate }}</p>
              <button class="mt-1" *ngFor="let type of functionService.gradientDirectionList" nz-tooltip [nzTooltipTitle]="type.name | translate"
                style="height:30px;width: 30px; margin: 0px 5px" (click)="chooseOption(type, $event)"
                [style.background]=" 'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'"></button>
            </div>

            <!-- Loai màu thông thường -->
            <div class="items__color" *ngIf="!(config['background-color'].gradient_check)">
              <p class="m-0 title">{{'mau_nen' | translate}}</p>
              <!-- <input type="color" class="input-color" [value]="class.shape__child['background']"
                [(ngModel)]="class.shape__child['background']" (blur)="updateClass()"> -->
              <div class="w-50"> <input class="input-color w-100" type="button" [cpOKButton]="true"
                  [(colorPicker)]="class.shape__child['background']"
                  [style.background]="class.shape__child['background']" (colorPickerClose)="updateClass()"
                  [cpWidth]="'230px'" /></div>
            </div>
          </div>
          <!-- TÙY CHỌN ẢNH NỀN CHO HÌNH DẠNG -->
          <div class="check-option" *ngIf="config['background-color'].bg_check === 'image'">
            <div class="items custom-flex">
              <label>{{ 'hinh_anh' | translate }}</label>
              <nz-select [(ngModel)]="config['background-color'].switch_image" (ngModelChange)="updateConfig()">
                <nz-option [nzValue]="1" [nzLabel]="'tai_anh_len' | translate"></nz-option>
                <nz-option [nzValue]="2" [nzLabel]="'duong_dan_hinh_anh' | translate"></nz-option>
                <nz-option [nzValue]="3" [nzLabel]="'chon_tu_thu_vien' | translate"></nz-option>
              </nz-select>
            </div>
            <input type="file" (change)="onUpload($event)" id="upload" style="opacity: 0" isUploadImage />
            <!-- <div class="item mt-2" *ngIf="config['background-color'].switch_image == '1'">
              <button [disabled]="!config['background-color']['is_load_image']" (click)="openUpload()"
                [ngClass]="{ disable: !config['background-color']['is_load_image'] }" class="upload-background-image">
                <i class="bi bi-plus-circle"></i> {{'tai_anh_len' | translate}}
              </button>
            </div> -->
            <!-- Kéo thả ảnh hoặc tải ảnh từ máy -->
            <div *ngIf="config['background-color'].switch_image == '1'" class="drop-zone item mt-2" [class.dragging]="dragging"
            (drop)="onFileDropped_upload($event)" (dragover)="onDragOver_upload($event)" (dragleave)="onDragLeave_upload()">
              <label *ngIf="!previewUploadUrl" for="upload">
                <mat-icon>image</mat-icon>
                <p>{{ 'keo_hinh_anh_vao_day_hoac' | translate }} <span>{{ 'tai_tep_len' | translate }}</span></p>
              </label>

              <div *ngIf="previewUploadUrl" class="preview">
                <img [src]="previewUploadUrl" alt="Preview" />
              </div>

              <div *ngIf="previewUploadUrl" class="gr-btn button-list">
                <button (click)="openUpload()">
                  <mat-icon>vertical_align_top</mat-icon>
                </button>
                <button (click)="previewUploadUrl = ''">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>
            <div class="w-mat-input mt-2" *ngIf="config['background-color'].switch_image == '2'">
              <div class="my-3">
                <mat-label class="title">{{'su_dung_duong_dan_hinh_anh' | translate}}</mat-label>
              </div>
              <div>
                <textarea rows="4" nz-input [(ngModel)]="config.background_image_restore"
                  (change)="handleImageAddress($event)"></textarea>
              </div>
            </div>
            <div class="item mt-2" *ngIf="config['background-color'].switch_image == '3'">
              <!-- <input type="file" (change)="onUpload($event)" id="upload" style="opacity: 0" isUploadImage /> -->
              <button [disabled]="!config['background-color']['is_load_image']" (click)="openLibrary()"
                [ngClass]="{ disable: !config['background-color']['is_load_image'] }" class="upload-background-image">
                <i class="bi bi-plus-circle"></i> {{'chon_anh_tu_thu_vien' | translate}}
              </button>
            </div>
            <!-- Độ bao phủ -->
            <div class="items__background--optimize">
              <p class="title">{{'dieu_chinh_do_bao_phu' | translate}}</p>
              <div class="items__background--optimize-options">
                <div *ngFor="let op of style_cover" style="cursor: pointer;">
                  <img [src]="op.image" alt="" [ngClass]="config?.option == op.name ? 'active' : ''" nz-tooltip
                    [nzTooltipTitle]="op.title" nzTooltipColor="blue" (click)="chooseOptionCover(op,$event)"
                    style="width: 50px !important">
                </div>
              </div>
            </div>
          </div>

          <!-- TÙY CHỌN ĐỘ MỜ CỦA HÌNH DẠNG -->
          <div class="items__blur-shape" *ngIf="config.switch_image == false" style="margin-top:10px">
            <div class="items">
              <p class="m-0 title">{{'do_mo' | translate}}</p>
              <nz-input-number [(ngModel)]="class.shape__parent.opacity" style="width:40%" [nzStep]=".1" [nzMax]="1"
                [nzMin]="0" (ngModelChange)="updateClass()"></nz-input-number>
            </div>
            <nz-slider style="width: 50%;" [(ngModel)]="class.shape__parent.opacity" [nzStep]=".1" [nzMax]="1"
              [nzMin]="0" (nzOnAfterChange)="updateClass()"></nz-slider>
          </div>

          <!-- TÙY CHON BO TRÒN HÌNH DẠNG-->
          <div class="border-shape items__border-radius" *ngIf="config.name == 'square-default'">
            <!-- Góc trên bên trái -->
            <div class="border-shape-items">
              <div class="items">
                <p class="m-0 title">{{'goc_tren_ben_trai' | translate}}</p>
                <input class="input-number" type="number" min="0" max="100"
                  [ngModel]="class.shape__child['border-top-left-radius'] | vhnumber" #topLeft
                  (ngModelChange)="onRadiusChange('border-top-left-radius', $event)"
                  (blur)="onRadiusBlur('border-top-left-radius', topLeft.value)" />
              </div>
              <nz-slider [ngModel]="class.shape__child['border-top-left-radius'] | vhnumber"
                [nzMin]="0" [nzMax]="100" [nzStep]="1"
                (ngModelChange)="onRadiusChange('border-top-left-radius', $event)"
                (nzOnAfterChange)="setBorder()">
              </nz-slider>
            </div>

            <!-- Góc dưới bên trái -->
            <div class="border-shape-items">
              <div class="items">
                <p class="m-0 title">{{'goc_duoi_ben_trai' | translate}}</p>
                <input class="input-number" type="number" min="0" max="100"
                  [ngModel]="class.shape__child['border-bottom-left-radius'] | vhnumber" #bottomLeft
                  (ngModelChange)="onRadiusChange('border-bottom-left-radius', $event)"
                  (blur)="onRadiusBlur('border-bottom-left-radius', bottomLeft.value)" />
              </div>
              <nz-slider [ngModel]="class.shape__child['border-bottom-left-radius'] | vhnumber"
                [nzMin]="0" [nzMax]="100" [nzStep]="1"
                (ngModelChange)="onRadiusChange('border-bottom-left-radius', $event)"
                (nzOnAfterChange)="setBorder()">
              </nz-slider>
            </div>

            <!-- Góc trên bên phải -->
            <div class="border-shape-items">
              <div class="items">
                <p class="m-0 title">{{'goc_tren_ben_phai' | translate}}</p>
                <input class="input-number" type="number" min="0" max="100"
                  [ngModel]="class.shape__child['border-top-right-radius'] | vhnumber" #topRight
                  (ngModelChange)="onRadiusChange('border-top-right-radius', $event)"
                  (blur)="onRadiusBlur('border-top-right-radius', topRight.value)" />
              </div>
              <nz-slider [ngModel]="class.shape__child['border-top-right-radius'] | vhnumber"
                [nzMin]="0" [nzMax]="100" [nzStep]="1"
                (ngModelChange)="onRadiusChange('border-top-right-radius', $event)"
                (nzOnAfterChange)="setBorder()">
              </nz-slider>
            </div>

            <!-- Góc dưới bên phải -->
            <div class="border-shape-items">
              <div class="items">
                <p class="m-0 title">{{'goc_duoi_ben_phai' | translate}}</p>
                <input class="input-number" type="number" min="0" max="100"
                  [ngModel]="class.shape__child['border-bottom-right-radius'] | vhnumber" #bottomRight
                  (ngModelChange)="onRadiusChange('border-bottom-right-radius', $event)"
                  (blur)="onRadiusBlur('border-bottom-right-radius', bottomRight.value)" />
              </div>
              <nz-slider [ngModel]="class.shape__child['border-bottom-right-radius'] | vhnumber"
                [nzMin]="0" [nzMax]="100" [nzStep]="1"
                (ngModelChange)="onRadiusChange('border-bottom-right-radius', $event)"
                (nzOnAfterChange)="setBorder()">
              </nz-slider>
            </div>

          </div>

        </div>
      </li>
      <!-- Lật hình -->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <app-rotate-config [classRotate]="class['shape']" [config]="config" [device]="device"
          [objectChoosing]="objectChoosing"></app-rotate-config>
      </li>
      <!-- Viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <div class="m-1">
          <!-- TÙY CHỈNH KÍCH CỠ VIỀN CHO HÌNH DẠNG -->
          <div class="items__border">
            <div class="d-flex justify-content-between align-items-center">
              <p class="m-0 title" style="line-height: 1.5;">{{'kich_thuoc_vien_tren' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="100" [ngModel]="class.shape__child.top | vhnumber"
                (nzBlur)="updateClass()" (ngModelChange)="class.shape__child.top = $event +'px'"></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="class.shape__child.top | vhnumber"
              (nzOnAfterChange)="updateClass()" (ngModelChange)="class.shape__child.top = $event +'px'"></nz-slider>
          </div>

          <div class="items__border">
            <div class="d-flex justify-content-between align-items-center">
              <p class="m-0 title" style="line-height: 1.5;">{{'kich_thuoc_vien_duoi' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="100" [ngModel]="class.shape__child.bottom | vhnumber"
                (nzBlur)="updateClass()" (ngModelChange)="class.shape__child.bottom = $event +'px'"></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="class.shape__child.bottom | vhnumber"
              (nzOnAfterChange)="updateClass()" (ngModelChange)="class.shape__child.bottom = $event +'px'"></nz-slider>
          </div>

          <div class="items__border">
            <div class="d-flex justify-content-between align-items-center">
              <p class="m-0 title" style="line-height: 1.5;">{{'kich_thuoc_vien_trai' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="100" [ngModel]="class.shape__child.left | vhnumber"
                (nzBlur)="updateClass()" (ngModelChange)="class.shape__child.left = $event +'px'"></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="class.shape__child.left | vhnumber"
              (nzOnAfterChange)="updateClass()" (ngModelChange)="class.shape__child.left = $event +'px'"></nz-slider>
          </div>

          <div class="items__border">
            <div class="d-flex justify-content-between align-items-center">
              <p class="m-0 title" style="line-height: 1.5;">{{'kich_thuoc_vien_phai' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="100" [ngModel]="class.shape__child.right | vhnumber"
                (nzBlur)="updateClass()" (ngModelChange)="class.shape__child.right = $event +'px'"></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="class.shape__child.right | vhnumber"
              (nzOnAfterChange)="updateClass()" (ngModelChange)="class.shape__child.right = $event +'px'"></nz-slider>
          </div>


          <!-- TÙY CHỈNH MÀU VIỀN -->
          <div class="items">
            <p class="w-50 title m-0">{{'mau_vien' | translate}}</p>
            <input class="input-color w-50" [cpOKButton]="true" [(colorPicker)]="class.shape__parent['background']"
              nztype="button" style="outline:none" [style.background]="class.shape__parent['background']"
              (colorPickerClose)="updateClass()" style="height: 25px" />
          </div>
        </div>
      </li>
      <!-- Đổ bóng -->
      <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu5"
        (nzOpenChange)="openHandler('menu5')">
        <!-- TÙY CHỌN ĐỔ BÓNG -->
        <!-- Chon trục X -->
        <div class="border-shape" style="margin-top:10px">
          <div class="items">
            <p class="m-0 title">{{'truc_x' | translate}}</p>
            <nz-input-number [nzMin]="-30" [nzMax]="30" [ngStyle]="{marginLeft: '16px',width: '40%'}"
              [(ngModel)]="config['box-shadow']['offset_x']" (ngModelChange)="boxShadow()" (nzBlur)="updateObject()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="-30" [nzMax]="30" [(ngModel)]="config['box-shadow']['offset_x']"
            (ngModelChange)="boxShadow()" (nzOnAfterChange)="updateObject()">
          </nz-slider>
        </div>
        <!-- Chon trục Y -->
        <div class="border-shape">
          <div class="items">
            <p class="m-0 title">{{'truc_y' | translate}}</p>
            <nz-input-number [nzMin]="-30" [nzMax]="30" [ngStyle]="{marginLeft: '16px',width: '40%'}"
              [(ngModel)]="config['box-shadow']['offset_y']" (ngModelChange)="boxShadow()" (nzBlur)="updateObject()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="-30" [nzMax]="30" [(ngModel)]="config['box-shadow']['offset_y']"
            (ngModelChange)="boxShadow()" (nzOnAfterChange)="updateObject()">
          </nz-slider>
        </div>
        <!-- Chon độ mờ -->
        <div class="border-shape">
          <div class="items">
            <p class="m-0 title">{{'do_mo' | translate}}</p>
            <nz-input-number [nzMin]="-30" [nzMax]="30" [ngStyle]="{marginLeft: '16px',width: '40%'}"
              [(ngModel)]="config['box-shadow']['blur_radius']" (ngModelChange)="boxShadow()" (nzBlur)="updateObject()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="-30" [nzMax]="30" [(ngModel)]="config['box-shadow']['blur_radius']"
            (ngModelChange)="boxShadow()" (nzOnAfterChange)="updateObject()">
          </nz-slider>

        </div>
        <div class="items w-100 ">
          <p class="w-50 title">{{'mau_bong' | translate}}</p>
          <input class="input-color w-50" [cpOKButton]="true" [(colorPicker)]="config['box-shadow']['shadow_color']"
            nztype="button" style="outline:none" [style.background]="config['box-shadow']['shadow_color']"
            (colorPickerClose)="boxShadow(); updateObject()" style="height: 25px" />
        </div>
      </li>
      <!-- HIỆU ỨNG -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu6"
        (nzOpenChange)="openHandler('menu6')">
        <app-choose-animations-config [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
          [cursorClass]="class['shape']" [effect_hover]="effect_hover" [customize]="customize" [type]="'object'"
          [effectFileUsing]="'shape'">
        </app-choose-animations-config>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="this.config['animation-selected'].id != '000000'">
       <app-animations-config [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata" [id_object]="objectChoosing._id"
        [customize]="customize"></app-animations-config>
    </div>
  </div>
</div>